import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { User } from 'app/models/User';

@Directive({ selector: '[hasStorePermissions]' })
export class StorePermissionDirective implements OnInit {
  @Input('hasStorePermissions') permissions: any;
  private el: HTMLElement;

  constructor(el: ElementRef, private userService: User) {
    this.el = el.nativeElement;
  }

  ngOnInit(): void {
    if (
      this.permissions &&
      !this.userService.hasPermissions(this.permissions)
    ) {
      this.el.remove();
    }
  }
}
